/**
 * Fetch exact system + user prompts for a leaf group (no OpenRouter call)
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation } from '@tanstack/react-query';

import api from '@/services/api';

import type { GenerationPromptPreview } from '../types/campaign-texts.types';

export function useGenerationPromptPreview() {
  return useMutation({
    mutationFn: async (vars: { groupId: string; countryKey: string; amount?: number }) => {
      const r = await api.get('/campaign-texts/generation-prompt-preview', {
        params: {
          groupId: vars.groupId,
          countryKey: vars.countryKey,
          amount: vars.amount ?? 8,
        },
      });
      return r.data.data as GenerationPromptPreview;
    },
  });
}
